import { render, staticRenderFns } from "./TrainNumberItem.vue?vue&type=template&id=a239d5f4&scoped=true"
import script from "./TrainNumberItem.vue?vue&type=script&lang=js"
export * from "./TrainNumberItem.vue?vue&type=script&lang=js"
import style0 from "./TrainNumberItem.vue?vue&type=style&index=0&id=a239d5f4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a239d5f4",
  null
  
)

export default component.exports